// Function to check if the device is mobile (you might have a more sophisticated check)
export const isMobileDevice = () => {
    // Simple check based on window width, adjust as needed
    // Consider using a library or more robust feature detection for better accuracy
    return window.innerWidth < 768; 
};

// Transform video source to low quality version if needed
export const getOptimizedVideoSrc = (originalSrc) => {
    if (!originalSrc) return originalSrc;

    // Check if we should use low quality version - NOW ONLY MOBILE
    const shouldUseOptimized = isMobileDevice();
    
    if (shouldUseOptimized) {
        // Replace /assets/ with /assets/low/
        return originalSrc.replace('/assets/', '/assets/low/');
    }

    return originalSrc;
}; 